export default "__VITE_ASSET__e0f56ee8__"